import styled from 'styled-components'
import { ReactComponent as BaseInformationIcon } from '@sketch/icons/information-16'

export const InformationIcon = styled(BaseInformationIcon)`
  width: 16px;
  display: block;
`
